"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parentUserIdSelector = void 0;
const prop_1 = __importDefault(require("ramda/src/prop"));
const authenticationSelector_1 = __importDefault(require("root/src/client/logic/auth/selectors/authenticationSelector"));
const cookies_1 = require("root/src/client/v2/browser/helpers/cookies");
function parentUserIdSelector(state) {
    return (0, cookies_1.getCookie)('parentUserId') || (0, prop_1.default)('parentUserId', (0, authenticationSelector_1.default)(state));
}
exports.parentUserIdSelector = parentUserIdSelector;
